/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useCallback, useMemo, memo } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link, useHistory } from "react-router-dom";
import * as Actions from "actions";
import {
  Card, IconButton, Box, Typography, Button,
} from "@mui/material";
import { getImage, getPrice } from "helpers/utils";

import "./UserProductItem.scss";
import HoverBox from "components/HoverBox";
import LazyImage from "components/LazyImage";
import { FlexBetween } from "components/flex-box";
import { H2, H6 } from "components/CustomTypography";
import ArrowRight from "@mui/icons-material/ArrowRight";
import PlayCircleIcon from '@mui/icons-material/PlayCircle';


const UserProductItem = memo((props) => {
  const [state, setState] = useState({
    open: false,
    stock: "InStock",
    quantity: 1,
    image: "",
  });

  const history = useHistory();

  const {
    product, onBottomClick, onMainClick, onAddToWishlistClicked, isDirect, currency, linkMain, linkArrow, onArrowClick
  } = props;

  // Memoize expensive calculations
  const productImage = useMemo(() => getImage(product.images), [product.images]);
  const productPrice = useMemo(() => getPrice(product, currency), [product, currency]);
  
  // Memoize static URLs to prevent recreation on each render
  const iconUrls = useMemo(() => ({
    veg: `${process.env.PUBLIC_URL}/assets/images/GreenIcon.png`,
    nonVeg: `${process.env.PUBLIC_URL}/assets/images/RedIcon.png`,
  }), []);

  const handleLinkMainClick = () => {
    if (linkMain) {
      history.push(`${linkMain}`);
    } else {
      history.push(`/products/${product.id}`);
    }
  };

  const handleLinkArrowClick = () => {
    if (linkArrow) {
      history.push(`${linkArrow}`);
    } else {
      history.push(`/products/${product.id}`);
    }
  };

  return (
    <Box pb={3}
         sx={{
           position: 'relative', // Needed to anchor the arrow inside this box
         }}>
      <HoverBox mb={0} mx="auto" borderRadius="2px" onClick={isDirect ? handleLinkMainClick : onMainClick}>
        <LazyImage
          src={productImage}
          width="100%"
          alt={product.name}
          mx="auto"
        />
      </HoverBox>
      <FlexBetween mt={0} onClick={isDirect ? handleLinkMainClick : onBottomClick}>
        <Box width="10%">
          <ArrowRight fontSize="small" color="primary" />
        </Box>
        <Box width="90%">
          <H2 fontSize={14} textAlign="left" ellipsis>
            {productPrice}
          </H2>
          <H6 textTransform="uppercase" fontSize={10} textAlign="left" ellipsis>
            {product.title}
          </H6>
          <H6 textTransform="capitalize" fontSize={10} textAlign="left" title={product.area} ellipsis>
            {product.area}
          </H6>
        </Box>
      </FlexBetween>
      <IconButton
          onClick={isDirect ? handleLinkArrowClick : onArrowClick}
          sx={{
            position: 'absolute',
            bottom: 60,
            right: 8,
            backgroundColor: 'white',
            color: 'primary.main',
            width: 16,
            height: 16,
            zIndex: 1,
            '&:hover': {
              backgroundColor: 'primary.dark',
            },
          }}
      >
        <PlayCircleIcon fontSize="medium" />
      </IconButton>
    </Box>
  );
});

// Add display name for debugging
UserProductItem.displayName = 'UserProductItem';

UserProductItem.defaultProps = {
  currency: 'USD',
  isDirect: false,
  link: null,
  linkArrow: null,
};

UserProductItem.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    images: PropTypes.array,
    name: PropTypes.string,
    title: PropTypes.string,
    area: PropTypes.string,
  }).isRequired,
  onBottomClick: PropTypes.func,
  onMainClick: PropTypes.func,
  onArrowClick: PropTypes.func,
  onAddToWishlistClicked: PropTypes.func,
  isDirect: PropTypes.bool,
  currency: PropTypes.string,
  link: PropTypes.string,
  linkArrow: PropTypes.string,
};

// Optimize Redux connection with shallow equality check
const mapStateToProps = ({ userproducts, bootupInfo }) => ({
  bootupInfo,
  reqStatus: userproducts.reqStatus,
  isLoading: userproducts.isLoading,
  serviceError: userproducts.serviceError,
  productprices: userproducts.productprices,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ ...Actions }, dispatch);

// Use React.memo with custom comparison function for better performance
const areEqual = (prevProps, nextProps) => {
  // Only re-render if product data, currency, or key props change
  return (
    prevProps.product.id === nextProps.product.id &&
    prevProps.currency === nextProps.currency &&
    prevProps.isDirect === nextProps.isDirect &&
    prevProps.link === nextProps.link &&
    JSON.stringify(prevProps.product.images) === JSON.stringify(nextProps.product.images)
  );
};

const MemoizedUserProductItem = memo(UserProductItem, areEqual);

const userProductItem = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MemoizedUserProductItem);

export default userProductItem;
